import { Grid, Typography } from 'antd';
import { isNil } from 'lodash/fp';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { useThemeComponents } from '../../../../themes';
import breakpoints from '../../../../utilities/breakpoints';
import Stepper, { MobilityPageKind, AvailableSteps as MobilitySteps } from '../Components/Stepper';
import CarFilterOnLargeScreen from './CarFilter/CarFilterOnLargeScreen';
import CarFilterOnSmallScreen from './CarFilter/CarFilterOnSmallScreen';
import { useCarListingState } from './CarListingStateProvider';
import CarSelection from './CarSelection';

const InfiniteScrollContainer = styled.div`
    width: 100%;
`;

const Root = styled.div`
    @media screen and (max-width: ${breakpoints.md}) {
        & .ant-pro-page-container-children-content {
            margin: 0;

            & > div {
                margin-top: 0;
            }
        }
    }
`;

const Container = styled.div`
    @media screen and (min-width: ${breakpoints.md}) {
        display: flex;
        margin: 36px;
    }

    margin: 1rem;
    min-height: calc(100vh - 246px);
`;

const CarListingInner = () => {
    const { t } = useTranslation(['mobilityVehicleList']);
    const { MobilityWebpageLayout } = useThemeComponents();

    const {
        state: { total, stocks, page },
        actions,
        meta: { loading },
    } = useCarListingState();

    const next = useCallback(() => {
        if (stocks.length < total && !loading) {
            actions.setPage(page + 1);
        }
    }, [actions, loading, page, stocks.length, total]);

    const screens = Grid.useBreakpoint();

    return (
        <Root>
            <MobilityWebpageLayout
                style={{ background: '#fff', height: '100%' }}
                title={<Typography.Title level={5}>{t('mobilityVehicleList:title')}</Typography.Title>}
            >
                <Stepper currentPage={MobilityPageKind.Mobility} currentStep={MobilitySteps.VehicleSelection} />
                {!isNil(screens.md) && !screens.md && <CarFilterOnSmallScreen />}
                <Container>
                    <InfiniteScrollContainer>
                        <InfiniteScroll
                            dataLength={stocks.length}
                            hasMore={stocks.length < total}
                            loader={null}
                            next={next}
                            scrollThreshold={0.8}
                            style={{ overflow: 'hidden' }}
                        >
                            <CarSelection />
                        </InfiniteScroll>
                    </InfiniteScrollContainer>
                    {screens.md && <CarFilterOnLargeScreen />}
                </Container>
            </MobilityWebpageLayout>
        </Root>
    );
};

export default CarListingInner;
